<template>
  <div class="flex justify-center">
    <div class="relative overflow-x-auto bg-white border border-solid rounded-lg shadow-lg border-neutral-300">
      <div class="max-h-[calc(100vh-8rem)] overflow-y-auto">
        <HistoryView
          :users="users"
          @show-user-info="showUserInfo"
          @hide-user-info="hideUserInfo"
        />

        <!-- User Info Popover -->
        <UserInfoPopover
          v-if="userInfo"
          :user="activeUser"
          :initial-x="infoX"
          :initial-y="infoY"
          @close="hideUserInfo"
          :is-visible="userInfo"
        />
      </div>
    </div>
  </div>
</template>
  
  <script setup>
  import { ref, defineProps } from 'vue';
  import HistoryView from "@/components/ui/AdminDashboard/Views/HistoryView.vue";
  import UserInfoPopover from "@/components/ui/AdminDashboard/Popovers/UserInfoPopover.vue";
  
  defineProps({
    users: Array,
  });
  
  const userInfo = ref(false);
  const activeUser = ref({});
  const infoX = ref(0);
  const infoY = ref(0);
  
  function showUserInfo(user, x, y) {
    activeUser.value = user;
    userInfo.value = true;
    infoX.value = x;
    infoY.value = y;
  }
  
  function hideUserInfo() {
    userInfo.value = false;
  }
  </script>